<template>
  <div class="vertical-center-box" style="display:block;padding:5px 5px 5px 7px;background:#f4f5f6">
    <el-tag size="medium" @click="deleteFilter(null)" class="mr-r4" style="cursor:pointer">
      초기화
    </el-tag>
    <el-tag v-for="(filter, index) in filterList" :key="index" closable :type="filter.tagType" size="medium" @close="deleteFilter(filter)" class="mr-r4">
      {{filter.name}}
    </el-tag>
  </div>
</template>

<script>
import { isNil, isEqual, cloneDeep } from 'lodash';
import EventHistStatMixins from '@/mixins/event/event-hist-stats';

export default {
  name: 'WEventHistFilterBox',
  mixins: [EventHistStatMixins],
  data() {
    return {
      filterList: [],
    };
  },
  watch: {
    active: {
      handler(value) {
        if (!isNil(value) && value) {
          this.loadData();
        }
      },
      immediate: true,
    },
    selectedNode() {
      this.loadData();
    },
    analysisDateParams() {
      this.loadData();
    },
    filterList(to, from) {
      if (!isEqual(to, from)) {
        this.$emit('change-filter-list', to);
      }
    },
  },
  methods: {
    loadData() {
      if (this.filterList.length > 0) {
        this.filterList = [];
      }
    },
    setEventHistFilter(filter) {
      const filterList = cloneDeep(this.filterList);
      if (filter.selected) {
        filterList.push(filter);
      } else {
        let deleteFilter = null;
        if (isEqual(filter.type, 'eventlevel')) {
          deleteFilter = filterList.filter((item) => isEqual(item.eventlevelId, filter.eventlevelId))[0];
        } else if (filter.type === 'objDefine') {
          deleteFilter = filterList.filter((item) => isEqual(item.objDefineId, filter.objDefineId))[0];
        } else if (filter.type === 'obj') {
          deleteFilter = filterList.filter((item) => isEqual(item.objId, filter.objId))[0];
        } else if (filter.type === 'rsc') {
          deleteFilter = filterList.filter((item) => isEqual(item.rscMixKey, filter.rscMixKey))[0];
        }
        filterList.splice(filterList.indexOf(deleteFilter), 1);
      }
      this.filterList = filterList;
    },
    deleteFilter(filter) {
      const filterList = cloneDeep(this.filterList);
      if (!isNil(filter)) {
        let deletedFilter = filter;
        if (isEqual(filter.type, 'eventlevel')) {
          deletedFilter = filterList.filter((item) => isEqual(item.eventlevelId, filter.eventlevelId))[0];
        } else if (filter.type === 'objDefine') {
          deletedFilter = filterList.filter((item) => isEqual(item.objDefineId, filter.objDefineId))[0];
        } else if (filter.type === 'obj') {
          deletedFilter = filterList.filter((item) => isEqual(item.objId, filter.objId))[0];
        } else if (filter.type === 'rsc') {
          deletedFilter = filterList.filter((item) => isEqual(item.rscMixKey, filter.rscMixKey))[0];
        }
        filterList.splice(filterList.indexOf(deletedFilter), 1);
        this.filterList = filterList;
        this.$emit('delete-event-hist-filter', deletedFilter);
      } else if (isNil(filter)) {
        this.filterList = [];
        this.$emit('delete-event-hist-filter');
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/event/event-hist/components/EventHistFilterBox.vue